module.exports = __webpack_public_path__ + "img/surfing.6619d33.jpg";